module.exports = __webpack_public_path__ + "media/books/Books-WhoItsFor-Milestones-ca2d0465.jpg";